export default __webpack_public_path__ + "assets/1a470cc6d97e9b6151bb2bbb3af905a0.svg";